import { all, fork } from 'redux-saga/effects';
import paginationSaga from './pagination/saga';
import viewSaga from './view/saga';

function* requestSaga() {
    yield all([
        fork(paginationSaga),
        fork(viewSaga),
    ]);
}

export default requestSaga;
